import { classNames } from "@/shared/utils/classnames";
import React, { type FC } from "react";

export type TableHeaderColumnProps = JSX.IntrinsicElements["th"] & {};

export const TableHeaderColumn: FC<TableHeaderColumnProps> = ({
  className,
  ...props
}) => {
  return (
    <th
      className={classNames(
        "px-3 py-3.5 text-left text-sm font-semibold text-gray-900 whitespace-nowrap",
        className
      )}
      {...props}
    />
  );
};
